import { store } from "..";
import { queryScoutDisplayNames } from "../organisation/firestore/scouts";
import { setScoutNamesAction } from "./incidentReducer";

// Organisations we have already fetched (or are fetching) scout names for,
// so a page full of incidents only triggers a single read per organisation.
const requested = new Set<string>();

export const loadScoutNamesIfNeeded = (organisationId: string | undefined) => {
  if (!organisationId || requested.has(organisationId)) {
    return;
  }
  requested.add(organisationId);
  queryScoutDisplayNames(organisationId)
    .then((displayNames) => {
      store.dispatch(setScoutNamesAction(organisationId, displayNames));
    })
    .catch((error) => {
      // Allow a later render to retry
      requested.delete(organisationId);
      console.error("Failed to load scout names", organisationId, error);
    });
};
